import React, {Fragment, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Nav, Navbar, NavDropdown, Button, Modal, Container} from 'react-bootstrap';
import {push} from 'connected-react-router';
import {useTranslation} from 'react-i18next';
import Cookies from 'universal-cookie';
import Flags from 'country-flag-icons/react/3x2';
import {logout} from '../actions/login';
import {hideMessage} from '../actions/messages';
import {getOwnedFields, refreshPartnerProfile, getOwnedFieldBookings, getOwnedFieldSlots, ownedFieldSelected, ownedServiceSelected, partnerFieldsActiveTab, updatePartnerLanguage, getOwnedEvents, getVideosStorePartner, partnerGetStoragePrices, getUserTagsPartner, getTaggedUserVideosPartner, selectVideoForTaggingPartner, getPartnerVideos, myVideoActiveTab, getAffiliatedPlayers, getAffiliationRenewRequests} from '../actions/partner';
import {getNameFromProfile} from '../util';
import {ROLES} from '../constants';
import logo from '../images/replayer_logo_neg.svg';
import {refreshPlayerProfile, updatePlayerLanguage, getSponsors as getPlayerSponsor, selectVideoForTagging, getLiveVideos} from '../actions/player';
import {getSponsors, searchPartners, getNvrStatus} from '../actions/admin';
import menu_icon from '../images/menu_mobile.svg';
import player_icon from '../images/Replayer_default_Avatar.png';
import Configuration from '../config';
import NotificationBell from './notification-bell';
import RepContextualTip from './rep-contextual-tip';
import {
  FaCalendarAlt,
  FaBars,
  FaBuilding,
  FaCheckCircle,
  FaChevronLeft,
  FaChevronRight,
  FaHome,
  FaListAlt,
  FaPlayCircle,
  FaQuestionCircle,
  FaRobot,
  FaShoppingBag,
  FaSignOutAlt,
  FaStore,
  FaTv,
  FaUser,
  FaUserMd,
  FaUsers,
  FaVideo,
  FaWallet,
  FaEnvelopeOpenText
} from 'react-icons/fa';
import {
  CLUB_MODE_CHANGED_EVENT,
  activateClubMode,
  clearClubMode,
  getActiveClubPath
} from '../util/club-mode';
import * as api from '../api';
import {isPartnerOwnClubPath} from '../util/partner-club-access';
import ClubReturnButton from './club-return-button';

const MyNavbar = ({
  token,
  profile,
  message,
  hideMessage,
  logout,
  goto,
  showPartnerBookingCalendar,
  showPartnerServiceBookingCalendar,
  updatePartnerLanguage,
  updatePlayerLanguage,
  showMyVideo,
  ownedServices,
  showMyVideoPartner,
  showMyVideoPartnerSpecialist,
  gotoLiveVideos,
  gotoAffiliations,
  location,
  history
}) => {
  const {t, i18n} = useTranslation();
  const dedicatedClubPage = location.pathname.startsWith('/club/');
  const currentClubPath = dedicatedClubPage
    ? `${location.pathname}${location.search || ''}`
    : null;
  const [authenticatedClubPath, setAuthenticatedClubPath] = useState(getActiveClubPath());
  const [playerSidebarCollapsed, setPlayerSidebarCollapsed] = useState(false);
  const [playerTabletMenuOpen, setPlayerTabletMenuOpen] = useState(false);
  const [repEnabled, setRepEnabled] = useState(false);
  useEffect(() => {
    if (!token) {
      setRepEnabled(false);
      return undefined;
    }
    let active = true;
    const loadRepSetting = () => api.getRepSettings(token).then(response => {
      if (!active) return;
      if (response.status === 200 && typeof response.json.enabled === 'boolean') {
        setRepEnabled(response.json.enabled);
      } else {
        setRepEnabled(true);
      }
    });
    const handleChange = event => {
      if (event.detail && typeof event.detail.enabled === 'boolean') {
        setRepEnabled(event.detail.enabled);
      } else {
        loadRepSetting();
      }
    };
    loadRepSetting();
    const refreshTimer = window.setInterval(loadRepSetting, 60000);
    window.addEventListener('replayer:rep-feature-changed', handleChange);
    return () => {
      active = false;
      window.clearInterval(refreshTimer);
      window.removeEventListener('replayer:rep-feature-changed', handleChange);
    };
  }, [token]);
  useEffect(() => {
    const refreshClubAuth = () => setAuthenticatedClubPath(getActiveClubPath());
    window.addEventListener(CLUB_MODE_CHANGED_EVENT, refreshClubAuth);
    return () => window.removeEventListener(CLUB_MODE_CHANGED_EVENT, refreshClubAuth);
  }, []);
  useEffect(() => {
    if (
      dedicatedClubPage &&
      currentClubPath &&
      profile &&
      profile.user &&
      profile.user.role === ROLES.player &&
      authenticatedClubPath !== currentClubPath
    ) {
      activateClubMode(currentClubPath);
      setAuthenticatedClubPath(currentClubPath);
    }
  }, [authenticatedClubPath, currentClubPath, dedicatedClubPage, profile]);
  useEffect(() => {
    const showPlayerBottomNavigation = Boolean(
      profile &&
      profile.user &&
      [ROLES.player, ROLES.partner].includes(profile.user.role) &&
      !dedicatedClubPage
    );
    document.body.classList.toggle('has-mobile-player-bottom-nav', showPlayerBottomNavigation);
    return () => document.body.classList.remove('has-mobile-player-bottom-nav');
  }, [dedicatedClubPage, profile]);
  useEffect(() => {
    const showPlayerSidebar = Boolean(
      profile && profile.user && [ROLES.player, ROLES.partner].includes(profile.user.role) && !dedicatedClubPage
    );
    document.body.classList.toggle('has-player-desktop-sidebar', showPlayerSidebar);
    document.body.classList.toggle('player-desktop-sidebar-collapsed', showPlayerSidebar && playerSidebarCollapsed);
    return () => {
      document.body.classList.remove('has-player-desktop-sidebar');
      document.body.classList.remove('player-desktop-sidebar-collapsed');
    };
  }, [dedicatedClubPage, playerSidebarCollapsed, profile]);
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    const cookies = new Cookies();
    cookies.set('replayerLang', i18n.language);
    if (profile && profile.user.role === ROLES.partner) {
      updatePartnerLanguage(lng);
    } else if (profile && profile.user.role === ROLES.player) {
      updatePlayerLanguage(lng);
    }
  };

  const dedicatedPlayerMode = Boolean(
    profile &&
    profile.user.role === ROLES.player &&
    authenticatedClubPath
  );
  const dedicatedPartnerMode = Boolean(
    dedicatedClubPage &&
    isPartnerOwnClubPath(profile, location.pathname)
  );
  const currentLanguage = (i18n.language || 'it').split('-')[0];
  const profileAvatar = profile && profile.image && profile.image[0]
    ? `${Configuration.apiEndPoint}/images/${profile.uid}?load=${profile.image[0]}`
    : player_icon;
  const profileDropdownTitle = name => (
    <span className="navbar-profile-skywork-title">
      <img src={profileAvatar} alt="" aria-hidden="true"/>
      <span className="navbar-profile-skywork-name">{name}</span>
    </span>
  );
  const dropdownItemLabel = (Icon, label) => (
    <span className="navbar-profile-skywork-item-label">
      <Icon aria-hidden="true"/>
      <span>{label}</span>
    </span>
  );
  const languageFlag = language => (
    language === 'it' ? <Flags.IT/> :
    language === 'en' ? <Flags.GB/> :
    language === 'fr' ? <Flags.FR/> :
    <Flags.DE/>
  );
  const isPlayerSignUpSuccess = Boolean(message && message.body === 'SIGNING_UP_SUCCESSFUL');
  const isActiveMobilePath = paths => paths.some(path => (
    path === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(path)
  ));
  const playerBookableSportCentersPath = '/player-show-sport-centers?bookable=true';
  const sidebarGoto = (path, action = null) => event => {
    setPlayerTabletMenuOpen(false);
    goto(path, action)(event);
  };
  const sidebarAction = action => event => {
    setPlayerTabletMenuOpen(false);
    action(event);
  };
  const playerSidebar = profile && profile.user.role === ROLES.player && !dedicatedClubPage ? (
    <Fragment>
      <button
        type="button"
        className={`player-sidebar-backdrop ${playerTabletMenuOpen ? 'is-open' : ''}`}
        aria-label={t('NAV_CLOSE_MENU')}
        onClick={() => setPlayerTabletMenuOpen(false)}
      />
      <aside className={`player-desktop-sidebar ${playerSidebarCollapsed ? 'is-collapsed' : ''} ${playerTabletMenuOpen ? 'is-tablet-open' : ''}`} aria-label={t('NAV_PLAYER_NAVIGATION')}>
        <button type="button" className="player-sidebar-collapse d-none d-xl-flex" onClick={() => setPlayerSidebarCollapsed(value => !value)} aria-label={playerSidebarCollapsed ? t('NAV_EXPAND_MENU') : t('NAV_COLLAPSE_MENU')}>
          {playerSidebarCollapsed ? <FaChevronRight/> : <Fragment><FaChevronLeft/><span>{t('NAV_COLLAPSE')}</span></Fragment>}
        </button>
        <nav className="player-sidebar-links">
          <a className={isActiveMobilePath(['/']) ? 'active' : ''} href="/" onClick={sidebarGoto('/')}><FaHome/><span>{t('HOME')}</span></a>
          <a className={location.pathname === '/player-show-sport-centers' && !location.search.includes('bookable=true') ? 'active' : ''} href="/player-show-sport-centers" onClick={sidebarGoto('player-show-sport-centers')}><FaBuilding/><span>{t('SPORT_CENTERS')}</span></a>
          <a className={isActiveMobilePath(['/player-show-sport-specialists']) ? 'active' : ''} href="/player-show-sport-specialists" onClick={sidebarGoto('player-show-sport-specialists')}><FaUserMd/><span>{t('SPORT_SPECIALISTS')}</span></a>
          {repEnabled ? <a className={isActiveMobilePath(['/rep-assistant']) ? 'active' : ''} href="/rep-assistant" onClick={sidebarGoto('/rep-assistant')}><FaRobot/><span>{t('NAV_ASK_REP')}</span></a> : null}
          <a className={isActiveMobilePath(['/player-bookings']) ? 'active' : ''} href="/player-bookings" onClick={sidebarGoto('/player-bookings')}><FaListAlt/><span>{t('NAV_MY_BOOKINGS')}</span></a>
          <a
            className={location.pathname === '/player-show-sport-centers' && location.search.includes('bookable=true') ? 'active' : ''}
            href={playerBookableSportCentersPath}
            onClick={sidebarGoto(playerBookableSportCentersPath)}
          ><FaCalendarAlt/><span>{t('NAV_BOOK')}</span></a>
          <a className={isActiveMobilePath(['/player-open-matches']) ? 'active' : ''} href="/player-open-matches" onClick={sidebarGoto('/player-open-matches')}><FaUsers/><span>{t('OPEN_MATCHES')}</span></a>
          <a className={isActiveMobilePath(['/player-live-videos']) ? 'active' : ''} href="/player-live-videos" onClick={sidebarAction(gotoLiveVideos)}><FaVideo/><span>{t('LIVE_VIDEOS')}</span></a>
          <a className={isActiveMobilePath(['/player-video']) ? 'active' : ''} href="/player-video" onClick={sidebarAction(showMyVideo)}><FaPlayCircle/><span>{t('MY_VIDEO')}</span></a>
          <a href="/player-replayer-tv-home" onClick={sidebarGoto('player-replayer-tv-home')}><FaTv/><span>{t('REPLAYER_TV')}</span></a>
          <a href="/#special-events" onClick={sidebarGoto('/#special-events')}><FaCalendarAlt/><span>{t('SPECIAL_EVENTS')}</span></a>
          <a href="/shop" onClick={sidebarGoto('/shop')}><FaShoppingBag/><span>{t('SHOP')}</span></a>
          <a href="/player-profile" onClick={sidebarGoto('/player-profile', refreshPlayerProfile)}><FaUser/><span>{t('PROFILE')}</span></a>
          <a href="/user-top-up-account" onClick={sidebarGoto('user-top-up-account')}><FaUser/><span>{t('CREDIT')} &euro; {profile.user.wallet}</span></a>
          <a href="/player-sponsor" onClick={sidebarGoto('player-sponsor', getPlayerSponsor)}><FaCheckCircle/><span>{t('SPONSOR_OURS')}</span></a>
          <div className="player-sidebar-separator"/>
          <a href="https://www.replayer.it/it/video-tutorial-per-lutilizzo-dei-servizi-replayer/" target="_blank" rel="noopener noreferrer"><FaListAlt/><span>{t('VIDEO_TUTORIAL')}</span></a>
          <a href="https://www.replayer.it/it/aiuto/" target="_blank" rel="noopener noreferrer"><FaEnvelopeOpenText/><span>{t('HELP')}</span></a>
          <a href="/" onClick={sidebarAction(logout)}><FaSignOutAlt/><span>{t('EXIT')}</span></a>
        </nav>
      </aside>
    </Fragment>
  ) : null;
  const mobilePlayerNavigation = profile && profile.user.role === ROLES.player && !dedicatedClubPage ? (
    <nav className="mobile-player-bottom-nav d-md-none" aria-label={t('NAV_MAIN_NAVIGATION')}>
      <a className={isActiveMobilePath(['/player-replayer-tv-home']) ? 'active' : ''} href="/player-replayer-tv-home" onClick={goto('player-replayer-tv-home')} aria-current={isActiveMobilePath(['/player-replayer-tv-home']) ? 'page' : undefined}>
        <FaTv aria-hidden="true"/><span>{t('REPLAYER_TV')}</span>
      </a>
      <a className={isActiveMobilePath(['/player-calendars', '/player-booking-calendar', '/player-service-booking-calendar']) || (location.pathname === '/player-show-sport-centers' && location.search.includes('bookable=true')) ? 'active' : ''} href={playerBookableSportCentersPath} onClick={goto(playerBookableSportCentersPath)} aria-current={isActiveMobilePath(['/player-calendars', '/player-booking-calendar', '/player-service-booking-calendar']) || (location.pathname === '/player-show-sport-centers' && location.search.includes('bookable=true')) ? 'page' : undefined}>
        <FaCalendarAlt aria-hidden="true"/><span>{t('NAV_BOOK')}</span>
      </a>
      <a className={isActiveMobilePath(['/player-bookings']) ? 'active' : ''} href="/player-bookings" onClick={goto('/player-bookings')} aria-current={isActiveMobilePath(['/player-bookings']) ? 'page' : undefined}>
        <FaListAlt aria-hidden="true"/><span>{t('NAV_MY_BOOKINGS')}</span>
      </a>
      <a className={isActiveMobilePath(['/player-video']) ? 'active' : ''} href="/player-video" onClick={showMyVideo} aria-current={isActiveMobilePath(['/player-video']) ? 'page' : undefined}>
        <FaPlayCircle aria-hidden="true"/><span>{t('MY_VIDEO')}</span>
      </a>
      <a className={isActiveMobilePath(['/player-profile', '/user-top-up-account']) ? 'active' : ''} href="/player-profile" onClick={goto('/player-profile', refreshPlayerProfile)} aria-current={isActiveMobilePath(['/player-profile', '/user-top-up-account']) ? 'page' : undefined}>
        <FaUser aria-hidden="true"/><span>{t('PROFILE')}</span>
      </a>
    </nav>
  ) : null;
  const partnerSidebar = profile && profile.user.role === ROLES.partner && !dedicatedClubPage ? (
    <Fragment>
      <button
        type="button"
        className={`player-sidebar-backdrop ${playerTabletMenuOpen ? 'is-open' : ''}`}
        aria-label={t('NAV_CLOSE_MENU')}
        onClick={() => setPlayerTabletMenuOpen(false)}
      />
      <aside className={`player-desktop-sidebar ${playerSidebarCollapsed ? 'is-collapsed' : ''} ${playerTabletMenuOpen ? 'is-tablet-open' : ''}`} aria-label={t('NAV_PARTNER_NAVIGATION')}>
        <button type="button" className="player-sidebar-collapse d-none d-xl-flex" onClick={() => setPlayerSidebarCollapsed(value => !value)} aria-label={playerSidebarCollapsed ? t('NAV_EXPAND_MENU') : t('NAV_COLLAPSE_MENU')}>
          {playerSidebarCollapsed ? <FaChevronRight/> : <Fragment><FaChevronLeft/><span>{t('NAV_COLLAPSE')}</span></Fragment>}
        </button>
        <nav className="player-sidebar-links">
          <a className={isActiveMobilePath(['/partner-fields']) ? 'active' : ''} href="/partner-fields" onClick={sidebarGoto('partner-fields', getOwnedFields)}><FaBuilding/><span>{t('RESOURCES')}</span></a>
          {profile.dedicatedPageEnabled && profile.publicSlug ? <a href={`/club/${profile.publicSlug}`} onClick={sidebarGoto(`/club/${profile.publicSlug}`)}><FaHome/><span>{t('PARTNER_OWN_CLUB')}</span></a> : null}
          {profile.openMatchesEnabled ? <a className={isActiveMobilePath(['/partner-open-matches', '/matches/']) ? 'active' : ''} href="/partner-open-matches" onClick={sidebarGoto('/partner-open-matches')}><FaUsers/><span>{t('OPEN_MATCHES')}</span></a> : null}
          <a className={isActiveMobilePath(['/partner-booking-calendar', '/partner-service-booking-calendar']) ? 'active' : ''} href="/partner-booking-calendar" onClick={sidebarAction(showPartnerBookingCalendar)}><FaCalendarAlt/><span>{t('BOOKINGS')}</span></a>
          <a className={isActiveMobilePath(['/partner-affiliations']) ? 'active' : ''} href="/partner-affiliations" onClick={sidebarAction(gotoAffiliations)}><FaUser/><span>{t('MEMBERSHIPS')}</span></a>
          <a className={isActiveMobilePath(['/partner-replayer-tv-home']) ? 'active' : ''} href="/partner-replayer-tv-home" onClick={sidebarGoto('partner-replayer-tv-home')}><FaTv/><span>{t('REPLAYER_TV')}</span></a>
          <a className={isActiveMobilePath(['/partner-video']) ? 'active' : ''} href="/partner-video" onClick={sidebarAction(profile.isSpecialist ? showMyVideoPartnerSpecialist : showMyVideoPartner)}><FaPlayCircle/><span>{t('MY_VIDEO')}</span></a>
          {repEnabled ? <a className={isActiveMobilePath(['/rep-assistant']) ? 'active' : ''} href="/rep-assistant" onClick={sidebarGoto('/rep-assistant')}><FaRobot/><span>{t('NAV_ASK_REP')}</span></a> : null}
          <div className="player-sidebar-separator"/>
          <a href="/partner-events" onClick={sidebarGoto('partner-events', getOwnedEvents)}><FaCalendarAlt/><span>{t('SPECIAL_EVENTS')}</span></a>
          <a href="/partner-video-store" onClick={sidebarGoto('partner-video-store', getVideosStorePartner)}><FaStore/><span>{t('VIDEO_STORE')}</span></a>
          <a href="/partner-shop" onClick={sidebarGoto('/partner-shop')}><FaShoppingBag/><span>{t('SHOP')}</span></a>
          <a href="/shop" onClick={sidebarGoto('/shop')}><FaShoppingBag/><span>{t('REPLAYER_SHOP')}</span></a>
          <a href="/partner-report" onClick={sidebarGoto('partner-report')}><FaListAlt/><span>{t('REPORT')}</span></a>
          <a href="/player-sponsor" onClick={sidebarGoto('player-sponsor', getPlayerSponsor)}><FaCheckCircle/><span>{t('SPONSOR_OURS')}</span></a>
          <div className="player-sidebar-separator"/>
          <a href="/partner-profile" onClick={sidebarGoto('partner-profile', refreshPartnerProfile)}><FaUser/><span>{t('PROFILE')}</span></a>
          <a href="/" onClick={sidebarAction(logout)}><FaSignOutAlt/><span>{t('EXIT')}</span></a>
        </nav>
      </aside>
    </Fragment>
  ) : null;
  const mobilePartnerNavigation = profile && profile.user.role === ROLES.partner && !dedicatedClubPage ? (
    <nav className="mobile-player-bottom-nav d-md-none" aria-label={t('NAV_PARTNER_MAIN_NAVIGATION')}>
      <a className={isActiveMobilePath(['/partner-fields']) ? 'active' : ''} href="/partner-fields" onClick={goto('partner-fields', getOwnedFields)} aria-current={isActiveMobilePath(['/partner-fields']) ? 'page' : undefined}>
        <FaBuilding aria-hidden="true"/><span>{t('RESOURCES')}</span>
      </a>
      <a className={isActiveMobilePath(['/partner-booking-calendar', '/partner-service-booking-calendar']) ? 'active' : ''} href="/partner-booking-calendar" onClick={showPartnerBookingCalendar} aria-current={isActiveMobilePath(['/partner-booking-calendar', '/partner-service-booking-calendar']) ? 'page' : undefined}>
        <FaCalendarAlt aria-hidden="true"/><span>{t('BOOKINGS')}</span>
      </a>
      <a className={isActiveMobilePath(['/partner-affiliations']) ? 'active' : ''} href="/partner-affiliations" onClick={gotoAffiliations} aria-current={isActiveMobilePath(['/partner-affiliations']) ? 'page' : undefined}>
        <FaUser aria-hidden="true"/><span>{t('MEMBERSHIPS')}</span>
      </a>
      <a className={isActiveMobilePath(['/partner-replayer-tv-home']) ? 'active' : ''} href="/partner-replayer-tv-home" onClick={goto('partner-replayer-tv-home')} aria-current={isActiveMobilePath(['/partner-replayer-tv-home']) ? 'page' : undefined}>
        <FaTv aria-hidden="true"/><span>{t('REPLAYER_TV')}</span>
      </a>
      <a className={isActiveMobilePath(['/partner-video']) ? 'active' : ''} href="/partner-video" onClick={profile.isSpecialist ? showMyVideoPartnerSpecialist : showMyVideoPartner} aria-current={isActiveMobilePath(['/partner-video']) ? 'page' : undefined}>
        <FaPlayCircle aria-hidden="true"/><span>{t('MY_VIDEO')}</span>
      </a>
    </nav>
  ) : null;
  const signUpSuccessModal = (
    <Fragment>
      <Modal.Header className="signup-success-skywork-header" closeButton>
        <span className="signup-success-skywork-icon"><FaEnvelopeOpenText aria-hidden="true"/></span>
        <div>
          <span className="signup-success-skywork-eyebrow">{t('SIGN_UP_EMAIL_SENT_EYEBROW')}</span>
          <Modal.Title>{t('SIGN_UP_EMAIL_SENT_TITLE')}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="signup-success-skywork-body">
        <p>{t('SIGN_UP_EMAIL_SENT_BODY')}</p>
        <div className="signup-success-skywork-tip">
          <FaCheckCircle aria-hidden="true"/>
          <span>{t('SIGN_UP_EMAIL_SPAM_HINT')}</span>
        </div>
      </Modal.Body>
      <Modal.Footer className="signup-success-skywork-footer">
        <Button variant="outline-primary" onClick={hideMessage}>{t('CLOSE_BUTTON')}</Button>
        <Button href="/login" onClick={hideMessage}>{t('SIGN_UP_GO_TO_LOGIN')}</Button>
      </Modal.Footer>
    </Fragment>
  );

  if (dedicatedClubPage || dedicatedPlayerMode) {
    const activeClubPath = authenticatedClubPath || currentClubPath;
    const clubBasePath = (dedicatedClubPage ? location.pathname : activeClubPath || location.pathname).split(/[?#]/)[0];
    const visibleClubProfile = profile && (
      ![ROLES.partner, ROLES.admin].includes(profile.user.role) || dedicatedPartnerMode
    )
      ? profile
      : null;
    const authenticatedPartnerClubPage = Boolean(
      visibleClubProfile &&
      visibleClubProfile.user.role === ROLES.partner &&
      dedicatedPartnerMode
    );
    const authenticatedClubPage = Boolean(
      visibleClubProfile &&
      visibleClubProfile.user.role === ROLES.player &&
      activeClubPath
    );
    const profileName = visibleClubProfile && visibleClubProfile.user.role === ROLES.admin
      ? 'ADMIN'
      : visibleClubProfile
        ? getNameFromProfile(visibleClubProfile)
        : '';
    const accountRole = visibleClubProfile && visibleClubProfile.user.role === ROLES.player
        ? t('USER')
        : visibleClubProfile && visibleClubProfile.user.role === ROLES.admin
          ? 'Admin'
          : '';
    const accountProfilePath = visibleClubProfile && visibleClubProfile.user.role === ROLES.player
        ? '/player-profile'
        : '/';
    const accountProfileRefresh = visibleClubProfile && visibleClubProfile.user.role === ROLES.player
        ? refreshPlayerProfile
        : null;
    const loginPath = `/login?next=${encodeURIComponent(currentClubPath || location.pathname)}`;
    const signUpPath = `/sign-up-player?next=${encodeURIComponent(currentClubPath || location.pathname)}`;
    const enterClubLogin = event => {
      event.preventDefault();
      if (profile) {
        if ([ROLES.partner, ROLES.admin].includes(profile.user.role)) {
          clearClubMode();
          history.push(profile.user.role === ROLES.partner ? '/partner-fields' : '/');
          return;
        }
        activateClubMode(currentClubPath || location.pathname);
        return;
      }
      history.push(loginPath);
    };
    const logoutFromClub = event => {
      event.preventDefault();
      clearClubMode();
      logout();
      history.push(`/login?next=${encodeURIComponent(currentClubPath || clubBasePath)}`);
    };
    const leaveClubMode = event => {
      event.preventDefault();
      clearClubMode();
      history.push('/');
    };
    const goToClub = hash => event => {
      event.preventDefault();
      const target = `${clubBasePath}${hash || ''}`;
      history.push(target);
    };

    return (
      <Container>
        <Navbar expand="lg" bg="primary" variant="dark" fixed="top" className="bg_blue_rp pt-3 pb-3">
          <Navbar.Brand href={activeClubPath || location.pathname} onClick={goToClub()}>
            <img src={logo} alt={t('LOGO')} width="120"/>
          </Navbar.Brand>
          <ClubReturnButton role={profile && profile.user ? profile.user.role : null}/>
          <Nav className="mr-auto"/>
          {authenticatedPartnerClubPage ? (
            <Fragment>
              <button type="button" className="btn navbar-wallet-skywork mr-2" onClick={goto('/user-top-up-account')}>
                <span className="navbar-wallet-skywork-label">{t('WALLET')}</span><strong>&euro; {profile.user.wallet}</strong>
              </button>
              <NotificationBell token={token} history={history}/>
              <NavDropdown className="navbar-profile-skywork" title={profileDropdownTitle(getNameFromProfile(profile))} alignRight>
                <NavDropdown.Item href={clubBasePath} onClick={goToClub()}>{dropdownItemLabel(FaHome, t('PARTNER_OWN_CLUB'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-fields" onClick={goto('/partner-fields', getOwnedFields)}>{dropdownItemLabel(FaBuilding, t('RESOURCES'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-booking-calendar" onClick={showPartnerBookingCalendar}>{dropdownItemLabel(FaCalendarAlt, t('BOOKINGS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-affiliations" onClick={gotoAffiliations}>{dropdownItemLabel(FaUser, t('MEMBERSHIPS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-replayer-tv-home" onClick={goto('/partner-replayer-tv-home')}>{dropdownItemLabel(FaTv, t('REPLAYER_TV'))}</NavDropdown.Item>
                {profile.openMatchesEnabled ? <NavDropdown.Item href="/partner-open-matches" onClick={goto('/partner-open-matches')}>{dropdownItemLabel(FaUsers, t('OPEN_MATCHES'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="/partner-profile" onClick={goto('/partner-profile', refreshPartnerProfile)}>{dropdownItemLabel(FaUser, t('PROFILE'))}</NavDropdown.Item>
                <NavDropdown.Divider/>
                <NavDropdown.Item href="/" onClick={logoutFromClub}>{dropdownItemLabel(FaSignOutAlt, t('EXIT'))}</NavDropdown.Item>
              </NavDropdown>
            </Fragment>
          ) : authenticatedClubPage ? (
            <Fragment>
              {profile.user.role !== ROLES.admin && (
                <button type="button" className="btn navbar-wallet-skywork mr-2" onClick={goto('/user-top-up-account')}>
                  <span className="navbar-wallet-skywork-label">{t('WALLET')}</span><strong>&euro; {profile.user.wallet}</strong>
                </button>
              )}
              <NavDropdown className="navbar-profile-skywork" title={profileDropdownTitle(profileName)} alignRight>
                <NavDropdown.Item href={clubBasePath} onClick={goToClub()}>{dropdownItemLabel(FaHome, t('HOME'))}</NavDropdown.Item>
                <NavDropdown.Item href={`${clubBasePath}#club-live`} onClick={goToClub('#club-live')}>{dropdownItemLabel(FaVideo, t('LIVE_VIDEOS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-video" onClick={showMyVideo}>{dropdownItemLabel(FaPlayCircle, t('MY_VIDEO'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-bookings" onClick={goto('/player-bookings')}>{dropdownItemLabel(FaListAlt, t('BOOKINGS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-profile" onClick={goto('/player-profile', refreshPlayerProfile)}>{dropdownItemLabel(FaUser, t('PROFILE'))}</NavDropdown.Item>
                <NavDropdown.Item href="https://www.replayer.it/it/video-tutorial-per-lutilizzo-dei-servizi-replayer/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaListAlt, t('VIDEO_TUTORIAL'))}</NavDropdown.Item>
                <NavDropdown.Item href="https://www.replayer.it/it/aiuto/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaQuestionCircle, t('HELP'))}</NavDropdown.Item>
                <NavDropdown.Divider/>
                <NavDropdown.Item href="/" onClick={leaveClubMode}>{dropdownItemLabel(FaHome, 'Vai a Replayer completo')}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logoutFromClub}>{dropdownItemLabel(FaSignOutAlt, t('EXIT'))}</NavDropdown.Item>
              </NavDropdown>
            </Fragment>
          ) : visibleClubProfile ? (
            <Fragment>
              {profile.user.role !== ROLES.admin && (
                <button type="button" className="btn navbar-wallet-skywork mr-2" onClick={goto('/user-top-up-account')}>
                  <span className="navbar-wallet-skywork-label">{t('WALLET')}</span><strong>&euro; {profile.user.wallet}</strong>
                </button>
              )}
              <NavDropdown className="navbar-profile-skywork" title={profileDropdownTitle(`${profileName} (${accountRole})`)} alignRight>
                {profile.user.role !== ROLES.admin && (
                  <NavDropdown.Item
                    href={accountProfilePath}
                    onClick={goto(accountProfilePath, accountProfileRefresh)}
                  >
                    {t('PROFILE')}
                  </NavDropdown.Item>
                )}
                <NavDropdown.Item href="/" onClick={leaveClubMode}>{t('GO_TO_FULL_REPLAYER')}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logoutFromClub}>{t('EXIT')}</NavDropdown.Item>
              </NavDropdown>
            </Fragment>
          ) : (
            <Fragment>
              <Button
                href={signUpPath}
                onClick={goto(signUpPath)}
                variant="secondary"
                className="mr-2"
              >
                {t('SIGN_UP')}
              </Button>
              <Button href={loginPath} onClick={enterClubLogin} variant="outline-light">{t('LOGIN')}</Button>
            </Fragment>
          )}
        </Navbar>
        {mobilePlayerNavigation}
        <Modal className={`modal_rp ${isPlayerSignUpSuccess ? 'signup-success-skywork-modal' : ''}`} contentClassName={isPlayerSignUpSuccess ? 'signup-success-skywork-content' : 'bg_blue_rp'} show={message !== null} onHide={hideMessage}>
          {isPlayerSignUpSuccess ? signUpSuccessModal : (
            <Fragment>
              <Modal.Header closeButton>
                <Modal.Title>{message === null ? null : t(message.title)}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{message === null ? null : t(message.body, message.options)}</Modal.Body>
              <Modal.Footer><Button onClick={hideMessage}>{t('CLOSE_BUTTON')}</Button></Modal.Footer>
            </Fragment>
          )}
        </Modal>
      </Container>
    );
  }

  return (
    <Container>
      <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark" fixed="top" className="bg_blue_rp pt-3 pb-3">
        <Navbar.Brand href="/" onClick={profile !== null && profile.user.role === ROLES.partner ? goto('partner-fields', getOwnedFields) : goto('/')}>
          <img
            className="d-none d-md-block"
            src={logo}
            alt={t('LOGO')}
          />
          <img
            className="d-xs-block d-md-none"
            src={logo}
            alt={t('LOGO')}
            width="100"
          />
        </Navbar.Brand>
        <ClubReturnButton role={profile && profile.user ? profile.user.role : null}/>
        <Nav className="mr-auto"/>
        {
          /* Menù per ruolo partner */
          profile !== null && profile.user.role === ROLES.partner ?
            <Fragment>
              <button type="button" className="btn player-tablet-menu-toggle d-none d-md-inline-flex d-xl-none" onClick={() => setPlayerTabletMenuOpen(value => !value)} aria-label={t('NAV_OPEN_PARTNER_NAVIGATION')} aria-expanded={playerTabletMenuOpen}>
                <FaBars aria-hidden="true"/>
              </button>
              <button type="button" className="btn navbar-wallet-skywork mr-2" onClick={goto('user-top-up-account')}><span className="navbar-wallet-skywork-label">{t('WALLET')}</span><strong>&euro; {profile.user.wallet}</strong></button>
              <NotificationBell token={token} history={history}/>
              {/* Menù per schermi grandi */}
              <NavDropdown className="d-none d-md-block navbar-profile-skywork" title={profileDropdownTitle(getNameFromProfile(profile))} alignRight>
                <NavDropdown.Item href="/partner-fields" onClick={goto('/partner-fields', getOwnedFields)}>{dropdownItemLabel(FaBuilding, t('RESOURCES'))}</NavDropdown.Item>
                {profile.dedicatedPageEnabled && profile.publicSlug ? <NavDropdown.Item href={`/club/${profile.publicSlug}`} onClick={goto(`/club/${profile.publicSlug}`)}>{dropdownItemLabel(FaHome, t('PARTNER_OWN_CLUB'))}</NavDropdown.Item> : null}
                {profile.openMatchesEnabled ? <NavDropdown.Item href="/partner-open-matches" onClick={goto('/partner-open-matches')}>{dropdownItemLabel(FaUsers, t('OPEN_MATCHES'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="/partner-events" onClick={goto('/partner-events', getOwnedEvents)}>{dropdownItemLabel(FaCalendarAlt, t('SPECIAL_EVENTS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-profile" onClick={goto('partner-profile', refreshPartnerProfile)}>{dropdownItemLabel(FaUser, t('PROFILE'))}</NavDropdown.Item>
                {repEnabled ? <NavDropdown.Item href="/rep-assistant" onClick={goto('/rep-assistant')}>{dropdownItemLabel(FaRobot, t('NAV_ASK_REP'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="https://www.replayer.it/it/aiuto/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaQuestionCircle, t('HELP'))}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logout}>{dropdownItemLabel(FaSignOutAlt, t('EXIT'))}</NavDropdown.Item>
              </NavDropdown>
              {/* Menù per schermi piccoli */}
              <NavDropdown className="d-xs-block d-sm-block d-md-none" title={<img src={menu_icon} alt={t('MENU')} width={30} />} alignRight>
                <NavDropdown.Item href="/partner-fields" onClick={goto('/partner-fields', getOwnedFields)}>{dropdownItemLabel(FaBuilding, t('RESOURCES'))}</NavDropdown.Item>
                {profile.dedicatedPageEnabled && profile.publicSlug ? <NavDropdown.Item href={`/club/${profile.publicSlug}`} onClick={goto(`/club/${profile.publicSlug}`)}>{dropdownItemLabel(FaHome, t('PARTNER_OWN_CLUB'))}</NavDropdown.Item> : null}
                {profile.openMatchesEnabled ? <NavDropdown.Item href="/partner-open-matches" onClick={goto('/partner-open-matches')}>{dropdownItemLabel(FaUsers, t('OPEN_MATCHES'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="/partner-profile" onClick={goto('partner-profile', refreshPartnerProfile)}>{dropdownItemLabel(FaUser, t('PROFILE'))}</NavDropdown.Item>
                {repEnabled ? <NavDropdown.Item href="/rep-assistant" onClick={goto('/rep-assistant')}>{dropdownItemLabel(FaRobot, t('NAV_ASK_REP'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="/partner-events" onClick={goto('partner-events', getOwnedEvents)}>{dropdownItemLabel(FaCalendarAlt, t('SPECIAL_EVENTS'))}</NavDropdown.Item>
                {ownedServices.length > 0 ? <NavDropdown.Item href="/partner-service-booking-calendar" onClick={showPartnerServiceBookingCalendar}>{dropdownItemLabel(FaCalendarAlt, t('SERVICES_BOOKING'))}</NavDropdown.Item> : null }
                <NavDropdown.Item href="/partner-video-store" onClick={goto('partner-video-store', getVideosStorePartner)}>{dropdownItemLabel(FaStore, t('VIDEO_STORE'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-shop" onClick={goto('/partner-shop')}>{dropdownItemLabel(FaShoppingBag, t('SHOP'))}</NavDropdown.Item>
                <NavDropdown.Item href="/shop" onClick={goto('/shop')}>{dropdownItemLabel(FaShoppingBag, t('REPLAYER_SHOP'))}</NavDropdown.Item>
                <NavDropdown.Item href="/partner-report" onClick={goto('partner-report')}>{dropdownItemLabel(FaListAlt, t('REPORT'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-sponsor" onClick={goto('player-sponsor', getPlayerSponsor)}>{dropdownItemLabel(FaCheckCircle, t('SPONSOR_OURS'))}</NavDropdown.Item>
                {
                  profile.user.wallet > 5 ?
                    <NavDropdown.Item href="/user-top-up-account" onClick={goto('user-top-up-account')}>{dropdownItemLabel(FaWallet, <Fragment>{t('WALLET')} &euro; {profile.user.wallet}</Fragment>)}</NavDropdown.Item> :
                    <NavDropdown.Item href="/user-top-up-account" style={{color: 'red'}} onClick={goto('user-top-up-account')}>{dropdownItemLabel(FaWallet, t('ACCOUNT_TOPUP'))}</NavDropdown.Item>
                }
                <NavDropdown.Item href="https://www.replayer.it/it/aiuto/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaQuestionCircle, t('HELP'))}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logout}>{dropdownItemLabel(FaSignOutAlt, t('EXIT'))}</NavDropdown.Item>
              </NavDropdown>
            </Fragment> :
            null
        }
        {
          /* Menù per ruolo player */
          profile !== null && profile.user.role === ROLES.player ?
            <Fragment>
              <button type="button" className="btn player-tablet-menu-toggle d-none d-md-inline-flex d-xl-none" onClick={() => setPlayerTabletMenuOpen(value => !value)} aria-label={t('NAV_OPEN_NAVIGATION')} aria-expanded={playerTabletMenuOpen}>
                <FaBars aria-hidden="true"/>
              </button>
              <button type="button" className={profile.user.wallet >= 0 ? "btn navbar-wallet-skywork mr-2" : "btn navbar-wallet-skywork navbar-wallet-skywork--negative mr-2"} onClick={goto('user-top-up-account')}><span className="navbar-wallet-skywork-label">{t('WALLET')}</span><strong>&euro; {profile.user.wallet}</strong></button>
              <NotificationBell token={token} history={history}/>
              {/* Menù per schermi grandi */}
              <NavDropdown className="d-none d-md-block navbar-profile-skywork" title={profileDropdownTitle(getNameFromProfile(profile))} alignRight>
                <NavDropdown.Item href="/" onClick={goto('/')}>{dropdownItemLabel(FaHome, t('HOME'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-show-sport-centers" onClick={goto('player-show-sport-centers')}>{dropdownItemLabel(FaBuilding, t('SPORT_CENTERS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-show-sport-specialists" onClick={goto('player-show-sport-specialists')}>{dropdownItemLabel(FaUserMd, t('SPORT_SPECIALISTS'))}</NavDropdown.Item>
                {repEnabled ? <NavDropdown.Item href="/rep-assistant" onClick={goto('/rep-assistant')}>{dropdownItemLabel(FaRobot, t('NAV_ASK_REP'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="/player-bookings" onClick={goto('/player-bookings')}>{dropdownItemLabel(FaListAlt, t('NAV_MY_BOOKINGS'))}</NavDropdown.Item>
                <NavDropdown.Item href={playerBookableSportCentersPath} onClick={goto(playerBookableSportCentersPath)}>{dropdownItemLabel(FaCalendarAlt, t('NAV_BOOK'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-open-matches" onClick={goto('/player-open-matches')}>{dropdownItemLabel(FaUsers, t('OPEN_MATCHES'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-live-videos" onClick={gotoLiveVideos}>{dropdownItemLabel(FaVideo, t('LIVE_VIDEOS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-video" onClick={showMyVideo}>{dropdownItemLabel(FaPlayCircle, 'My Video')}</NavDropdown.Item>
                <NavDropdown.Item href="/player-replayer-tv-home" onClick={goto('player-replayer-tv-home')}>{dropdownItemLabel(FaTv, t('REPLAYER_TV'))}</NavDropdown.Item>
                <NavDropdown.Item href="/#special-events" onClick={goto('/#special-events')}>{dropdownItemLabel(FaCalendarAlt, t('SPECIAL_EVENTS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/shop" onClick={goto('/shop')}>{dropdownItemLabel(FaShoppingBag, 'Shop')}</NavDropdown.Item>
                <NavDropdown.Item href="/player-profile" onClick={goto('/player-profile', refreshPlayerProfile)}>{dropdownItemLabel(FaUser, t('PROFILE'))}</NavDropdown.Item>
                <NavDropdown.Item href="/user-top-up-account" style={{color: profile.user.wallet >= 0 ? '#dd004a' : 'red'}} onClick={goto('user-top-up-account')}>{dropdownItemLabel(FaWallet, `Credito € ${profile.user.wallet}`)}</NavDropdown.Item>
                <NavDropdown.Item href="/player-sponsor" onClick={goto('player-sponsor', getPlayerSponsor)}>{dropdownItemLabel(FaCheckCircle, t('SPONSOR_OURS'))}</NavDropdown.Item>
                <NavDropdown.Item href="https://www.replayer.it/it/video-tutorial-per-lutilizzo-dei-servizi-replayer/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaListAlt, t('VIDEO_TUTORIAL'))}</NavDropdown.Item>
                <NavDropdown.Item href="https://www.replayer.it/it/aiuto/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaQuestionCircle, t('HELP'))}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logout}>{dropdownItemLabel(FaSignOutAlt, t('EXIT'))}</NavDropdown.Item>
              </NavDropdown>
              {/* Menù per schermi piccoli */}
              <NavDropdown className="d-xs-block d-sm-block d-md-none navbar-profile-skywork navbar-profile-skywork--compact" title={profileDropdownTitle(getNameFromProfile(profile))} alignRight>
                <NavDropdown.Item href="/" onClick={goto('/')}>{dropdownItemLabel(FaHome, t('HOME'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-show-sport-centers" onClick={goto('player-show-sport-centers')}>{dropdownItemLabel(FaBuilding, t('SPORT_CENTERS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-show-sport-specialists" onClick={goto('player-show-sport-specialists')}>{dropdownItemLabel(FaUserMd, t('SPORT_SPECIALISTS'))}</NavDropdown.Item>
                {repEnabled ? <NavDropdown.Item href="/rep-assistant" onClick={goto('/rep-assistant')}>{dropdownItemLabel(FaRobot, t('NAV_ASK_REP'))}</NavDropdown.Item> : null}
                <NavDropdown.Item href="/player-open-matches" onClick={goto('/player-open-matches')}>{dropdownItemLabel(FaUsers, t('OPEN_MATCHES'))}</NavDropdown.Item>
                <NavDropdown.Item href="/player-live-videos" onClick={gotoLiveVideos}>{dropdownItemLabel(FaVideo, t('LIVE_VIDEOS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/#special-events" onClick={goto('/#special-events')}>{dropdownItemLabel(FaCalendarAlt, t('SPECIAL_EVENTS'))}</NavDropdown.Item>
                <NavDropdown.Item href="/shop" onClick={goto('/shop')}>{dropdownItemLabel(FaShoppingBag, 'Shop')}</NavDropdown.Item>
                <NavDropdown.Item href="/player-sponsor" onClick={goto('player-sponsor', getPlayerSponsor)}>{dropdownItemLabel(FaCheckCircle, t('SPONSOR_OURS'))}</NavDropdown.Item>
                <NavDropdown.Item href="https://www.replayer.it/it/video-tutorial-per-lutilizzo-dei-servizi-replayer/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaListAlt, t('VIDEO_TUTORIAL'))}</NavDropdown.Item>
                <NavDropdown.Item href="https://www.replayer.it/it/aiuto/" target="_blank" rel="noopener noreferrer">{dropdownItemLabel(FaQuestionCircle, t('HELP'))}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logout}>{dropdownItemLabel(FaSignOutAlt, t('EXIT'))}</NavDropdown.Item>
              </NavDropdown>
            </Fragment> :
            null
        }
        {
          /* Menù per ruolo admin */
          profile !== null && profile.user.role === ROLES.admin ?
            <Fragment>
              {/* Menù per schermi grandi */}
              <NavDropdown className="d-none d-md-block" title="ADMIN" alignRight>
                <NavDropdown.Item href="/" onClick={goto('/')}>{t('HOME')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-create-partner" onClick={goto('/admin-create-partner')}>{t('CREATE_PARTNER')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-partner-management" onClick={goto('/admin-partner-management')}>{t('PARTNER_ADMINISTRATION')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-rtv-categories" onClick={goto('/admin-rtv-categories', searchPartners)}>{t('RTV_CHANNELS_CATEGORIES')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-player-management" onClick={goto('/admin-player-management')}>{t('PLAYER_ADMINISTRATION')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-slot-management" onClick={goto('/admin-slot-management')}>{t('SLOT_ADMINISTRATION')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-report" onClick={goto('/admin-report')}>{t('REPORT')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-additional-space" onClick={goto('/admin-additional-space')}>{t('ADDITIONAL_SPACE')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-sponsor" onClick={goto('/admin-sponsor', getSponsors)}>{t('SPONSOR')}</NavDropdown.Item>
                <NavDropdown.Item href="/nvr-dashboard" onClick={goto('/nvr-dashboard', getNvrStatus)}>{t('NVR_DASHBOARD')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-nvr-configuration" onClick={goto('/admin-nvr-configuration')}>{t('NVR_CONFIG_MENU')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-ai" onClick={goto('/admin-ai')}>{t('AI_VIDEO_ANALYSIS')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-rep" onClick={goto('/admin-rep')}>{t('IMPROVE_REP')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-setting" onClick={goto('/admin-setting')}>{t('SETTINGS')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-shop" onClick={goto('/admin-shop')}>{t('SHOP')}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logout}>{t('EXIT')}</NavDropdown.Item>
              </NavDropdown>
              {/* Menù per schermi piccoli */}
              <NavDropdown className="d-xs-block d-sm-block d-md-none" title={<img src={menu_icon} alt={t('LOGO')} width={30} />} alignRight>
                <NavDropdown.Item href="/" onClick={goto('/')}>{t('HOME')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-create-partner" onClick={goto('/admin-create-partner')}>{t('CREATE_PARTNER')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-partner-management" onClick={goto('/admin-partner-management')}>{t('PARTNER_ADMINISTRATION')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-rtv-categories" onClick={goto('/admin-rtv-categories', searchPartners)}>{t('RTV_CHANNELS_CATEGORIES')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-player-management" onClick={goto('/admin-player-management')}>{t('PLAYER_ADMINISTRATION')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-slot-management" onClick={goto('/admin-slot-management')}>{t('SLOT_ADMINISTRATION')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-report" onClick={goto('/admin-report')}>{t('REPORT')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-additional-space" onClick={goto('/admin-additional-space')}>{t('ADDITIONAL_SPACE')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-sponsor" onClick={goto('/admin-sponsor', getSponsors)}>{t('SPONSOR')}</NavDropdown.Item>
                <NavDropdown.Item href="/nvr-dashboard" onClick={goto('/nvr-dashboard', getNvrStatus)}>{t('NVR_DASHBOARD')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-nvr-configuration" onClick={goto('/admin-nvr-configuration')}>{t('NVR_CONFIG_MENU')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-ai" onClick={goto('/admin-ai')}>{t('AI_VIDEO_ANALYSIS')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-rep" onClick={goto('/admin-rep')}>{t('IMPROVE_REP')}</NavDropdown.Item>
                <NavDropdown.Item href="/admin-shop" onClick={goto('/admin-shop')}>{t('SHOP')}</NavDropdown.Item>
                <NavDropdown.Item href="/" onClick={logout}>{t('EXIT')}</NavDropdown.Item>
              </NavDropdown>
            </Fragment> :
            null
        }
        {
          <NavDropdown
            className="navbar-language-skywork"
            title={<span className="navbar-language-skywork-title">{languageFlag(currentLanguage)}<span>{currentLanguage.toUpperCase()}</span></span>}
            alignRight
          >
            <NavDropdown.Item active={currentLanguage === 'it'} onClick={() => changeLanguage('it')}><Flags.IT/><span>Italiano</span></NavDropdown.Item>
            <NavDropdown.Item active={currentLanguage === 'en'} onClick={() => changeLanguage('en')}><Flags.GB/><span>English</span></NavDropdown.Item>
            <NavDropdown.Item active={currentLanguage === 'fr'} onClick={() => changeLanguage('fr')}><Flags.FR/><span>Français</span></NavDropdown.Item>
            <NavDropdown.Item active={currentLanguage === 'de'} onClick={() => changeLanguage('de')}><Flags.DE/><span>Deutsch</span></NavDropdown.Item>
          </NavDropdown>
        }
      </Navbar>
      {playerSidebar}
      {partnerSidebar}
      {mobilePlayerNavigation}
      {mobilePartnerNavigation}
      {repEnabled && profile && [ROLES.player, ROLES.partner].includes(profile.user.role) && !dedicatedClubPage ? <RepContextualTip pathname={location.pathname} role={profile.user.role} openAssistant={question => history.push(`/rep-assistant?ask=${encodeURIComponent(question)}`)}/> : null}
      {repEnabled && profile && [ROLES.player, ROLES.partner].includes(profile.user.role) && !dedicatedClubPage ? <a className="rep-assistant-fab" href="/rep-assistant" onClick={goto('/rep-assistant')} aria-label={t('NAV_OPEN_REP_ASSISTANT')}><FaRobot/><span>{t('NAV_ASK_REP')}</span></a> : null}
      <Modal className={`modal_rp ${isPlayerSignUpSuccess ? 'signup-success-skywork-modal' : ''}`} contentClassName={isPlayerSignUpSuccess ? 'signup-success-skywork-content' : 'bg_blue_rp'} show={message !== null} onHide={hideMessage}>
        {isPlayerSignUpSuccess ? signUpSuccessModal : (
          <Fragment>
            <Modal.Header closeButton>
              <Modal.Title>{message === null ? null : t(message.title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message === null ? null : t(message.body, message.options)}</Modal.Body>
            <Modal.Footer><Button onClick={hideMessage}>{t('CLOSE_BUTTON')}</Button></Modal.Footer>
          </Fragment>
        )}
      </Modal>
    </Container>
  );
};

MyNavbar.propTypes = {
  token: PropTypes.string,
  profile: PropTypes.object,
  message: PropTypes.object,
  goto: PropTypes.func.isRequired,
  hideMessage: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  showPartnerBookingCalendar: PropTypes.func.isRequired,
  showPartnerServiceBookingCalendar: PropTypes.func.isRequired,
  updatePartnerLanguage: PropTypes.func.isRequired,
  updatePlayerLanguage: PropTypes.func.isRequired,
  showMyVideo: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }).isRequired,
  history: PropTypes.object.isRequired
};

MyNavbar.defaultProps = {
  token: null,
  profile: null,
  message: null,
  ownedServices: [],
};

const mapStateToProps = ({login: {token, profile}, partner: {ownedServices}, message, loading}) => ({
  token,
  profile,
  message,
  loading,
  ownedServices
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(logout());
  },
  hideMessage: () => {
    dispatch(hideMessage());
  },
  goto: (path, action = null) => e => {
    e.preventDefault();
    if (action) {
      dispatch(action());
    }

    const targetPath = path && path.startsWith('/') ? path : `/${path || ''}`;
    dispatch(push(targetPath));
  },
  showPartnerBookingCalendar: e => {
    e.preventDefault();
    dispatch(getOwnedFieldBookings(new Date(), 'WEEK'));
    dispatch(getOwnedFieldSlots(null, true, 'field', new Date(), 'WEEK'));
    dispatch(ownedFieldSelected(null));
    dispatch(partnerFieldsActiveTab('campi'));
    dispatch(push('/partner-booking-calendar'));
  },
  showPartnerServiceBookingCalendar: e => {
    e.preventDefault();
    dispatch(getOwnedFieldBookings(new Date(), 'WEEK', 'service'));
    dispatch(getOwnedFieldSlots(null, true, 'service', new Date(), 'WEEK'));
    dispatch(ownedServiceSelected(null));
    dispatch(partnerFieldsActiveTab('servizi'));
    dispatch(push('/partner-service-booking-calendar'));
  },
  updatePartnerLanguage: language => {
    dispatch(updatePartnerLanguage(language));
  },
  updatePlayerLanguage: language => {
    dispatch(updatePlayerLanguage(language));
  },
  showMyVideo: e => {
    e.preventDefault();
    dispatch(selectVideoForTagging(null));
    dispatch(push('/player-video'));
  },
  showMyVideoPartner: e => {
    e.preventDefault();
    dispatch(getUserTagsPartner());
    dispatch(getPartnerVideos());
    dispatch(getTaggedUserVideosPartner());
    dispatch(partnerGetStoragePrices());
    dispatch(selectVideoForTaggingPartner(null));
    dispatch(push('/partner-video'));
  },
  showMyVideoPartnerSpecialist: e => {
    e.preventDefault();
    dispatch(getUserTagsPartner());
    dispatch(getPartnerVideos());
    dispatch(getTaggedUserVideosPartner());
    dispatch(partnerGetStoragePrices());
    dispatch(selectVideoForTaggingPartner(null));
    dispatch(myVideoActiveTab("partner_videos"));
    dispatch(push('/partner-video'));
  },
  gotoLiveVideos: e => {
    e.preventDefault();
    dispatch(getLiveVideos());
    dispatch(push('/player-live-videos'));
  },
  gotoAffiliations: e => {
    e.preventDefault();
    dispatch(getAffiliatedPlayers());
    dispatch(getAffiliationRenewRequests());
    dispatch(push('/partner-affiliations'));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(MyNavbar));
